import { EditorContent, useEditor } from '@tiptap/react';
import { useEffect } from 'react';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import Tooltip from './Tooltip';
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import { Card, Typography } from 'antd';
import MenuBar from './MenuBar';
import Superscript from '@tiptap/extension-superscript';
import CharacterCount from '@tiptap/extension-character-count';
import './style.css';

const TipTap = ({ value, onChange, readonly = false, MAX_CHARS = 0 }) => {
  const initialContent = value || {
    type: 'doc',
    content: []
  };

  const editor = useEditor(
    {
      extensions: [
        StarterKit,
        Tooltip,
        Superscript,
        Underline,
        Link,
        CharacterCount.configure({
          limit: MAX_CHARS
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph', 'title']
        })
      ],
      content: value || initialContent,
      editable: !readonly,
      onUpdate: ({ editor }) => {
        if (!readonly) {
          const text = editor.state.doc.textBetween(0, editor.state.doc.content.size, ' ');
          const charCount = text.length;
          if (MAX_CHARS === 0 || charCount <= MAX_CHARS) {
            onChange(editor.getJSON());
          }
        }
      }
    },
    [readonly]
  ); // Re-create editor when readonly changes

  // Update editor editability when readonly prop changes
  useEffect(() => {
    if (editor) {
      editor.setEditable(!readonly);
    }
  }, [editor, readonly]);

  return (
    <Card styles={readonly ? { body: { padding: '8px 12px' } } : undefined}>
      {editor && !readonly && <MenuBar editor={editor} />}
      <div className="compass-editor" style={readonly ? { paddingTop: 0 } : undefined}>
        <EditorContent editor={editor} />
        {MAX_CHARS > 0 && (
          <Typography.Text type="secondary">
            {editor?.storage?.characterCount?.characters()}/{MAX_CHARS} characters
          </Typography.Text>
        )}
        {readonly && (
          <style>
            {`
              .ProseMirror {
                padding-top: 8px !important;
              }
            `}
          </style>
        )}
      </div>
    </Card>
  );
};

export default TipTap;
